import React from 'react';

const GoalProgress = ({ goals, getProgressColor }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Goal Progress</h3>
      <div className="space-y-4">
        {goals && goals.length > 0 ? (
          goals.map(goal => (
            <div key={goal.id}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-700">{goal.title}</span>
                <span className="text-sm text-gray-600">{goal.current}/{goal.target}</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div 
                  className={`h-2 rounded-full ${getProgressColor(goal.progress)}`}
                  style={{ width: `${goal.progress}%` }}
                ></div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-8 text-gray-500">
            <p className="text-sm">No goals set yet</p>
            <p className="text-xs mt-1">Set some professional goals to track your progress</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default GoalProgress;
